import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { DRAWER_PADDING_SCALE } from './SwipeableDrawer.constants';

const DRAWER_PADDING_OFFSET = `-${spacing(DRAWER_PADDING_SCALE)}`;

export const $DrawerFooter = styled.div<{ $hasPadding?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing('lg')};
  position: sticky;
  bottom: ${({ $hasPadding }) => ($hasPadding ? DRAWER_PADDING_OFFSET : '0')};
  margin-top: auto;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};

  padding: ${({ $hasPadding }) =>
    `${spacing('lg')} ${$hasPadding ? '0' : spacing('lg')}`};

  border-top: 1px solid ${({ theme }) => theme.newUI.variationColors.light5};

  margin-left: ${({ $hasPadding }) =>
    $hasPadding ? DRAWER_PADDING_OFFSET : '0'};
  margin-right: ${({ $hasPadding }) =>
    $hasPadding ? DRAWER_PADDING_OFFSET : '0'};
  margin-bottom: ${({ $hasPadding }) =>
    $hasPadding ? DRAWER_PADDING_OFFSET : '0'};

  z-index: 10;
`;
